/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import ImageSeries from './ImageSeries/index'
import Images from './Images/index'
import React from 'react'
import ShowDeletedCheckbox from './ShowDeletedCheckbox/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Images/ActiveTab/Images/Content/Content/Content/Comparison/Content/Content/Actions/Choose/ImageSelect/Content/Content"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<ShowDeletedCheckbox
  viewPath={`${viewPath}/ShowDeletedCheckbox`}
/>
<ImageSeries
  viewPath={`${viewPath}/ImageSeries`}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Images
  viewPath={`${viewPath}/Images`}
/>
</div>
</div>
{children}
</React.Fragment>)
}